<template>
    <div>
        <PageHeader>
            <template #navbar>
                <Navbar />
            </template>
            <template #pagetitle>
                <PageTitle :pageTitle="$t('pages.titles.newsDetail')" />
            </template>
        </PageHeader>
        <SingleCasesStudyThree />
        <FreeTrial variant="light"/>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageHeader from '../Layout/PageHeader'
import PageTitle from '../Common/PageTitle'
import SingleCasesStudyThree from '../SingleCasesStudy/SingleCasesStudyThree'
import FreeTrial from '../Common/FreeTrial'
import Footer from '../Layout/Footer'

export default {
    name: 'SingleNewsThreePage',
    components: {
        Navbar,
        PageHeader,
        PageTitle,
        SingleCasesStudyThree,
        FreeTrial,
        Footer,
    }
}
</script>
